import { render, staticRenderFns } from "./previewADDTOHOME.vue?vue&type=template&id=533f8595&scoped=true"
var script = {}
import style0 from "./previewADDTOHOME.vue?vue&type=style&index=0&id=533f8595&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533f8595",
  null
  
)

export default component.exports